import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';

export default makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      maxWidth: 360,
      backgroundColor: theme.palette.background.paper,
      justifyContent: 'center',
      alignItems: 'center'
    },
    paper: {
      width: '80%',
      maxHeight: 435,
    },
  }),
);